import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Normalize FastAPI structured error details into readable strings so downstream
// `toast.error(e.response.data.detail)` handlers never render an object as a React child.
// Also dispatch domain events (paywall, refund) so UI can react globally.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 402 && d && typeof d === "object") {
      if (d.code === "insufficient_credits") {
        window.dispatchEvent(new CustomEvent("geneo:insufficient-credits", { detail: d }));
      }
      if (d.code === "seedance_unavailable" && d.refunded) {
        window.dispatchEvent(new CustomEvent("geneo:credits-refunded", { detail: d }));
      }
    }
    if (d && typeof d === "object") {
      err.response.data.detail = d.message || JSON.stringify(d);
    }
    return Promise.reject(err);
  }
);
